import { getObservableT } from "../Infra/i18next";
import { SetupCompletionView } from "./AccountSetupCompletionView";
const t = getObservableT("patients");
export class PatientLoginSetupCompletionViewModel {
    constructor(container) {
        this.authManager = container.authManager;
        this.patientService = container.patientService;
        this.loginUIManager = container.loginUIManager;
        this.accountSetupCompletionManager = container.accountSetupCompletionManager;
        this.verifyOTPManager = container.verifyOTPManager;
        this.socialLoginAuthManager = container.socialLoginAuthManager;
        this.bannerUIManager = container.bannerUIManager;
        this.accountSetupCompletionManager.prepopulate(this.authManager.consentingPatientInfo);
    }
    get formModel() {
        return this.accountSetupCompletionManager.formModel;
    }
    get hasAgeValidationError() {
        return this.accountSetupCompletionManager.hasAgeValidationError;
    }
    get viewToDisplay() {
        return this.accountSetupCompletionManager.shouldShowPhoneOnlyScreen ? SetupCompletionView.PHONE_ONLY : SetupCompletionView.FULL_FORM;
    }
    async continue() {
        var _a;
        if (!this.accountSetupCompletionManager.validateInput())
            return;
        const pendingVerificationKey = (_a = this.socialLoginAuthManager.pendingSocialLoginData) === null || _a === void 0 ? void 0 : _a.verificationKey;
        const { input } = this.accountSetupCompletionManager;
        if (pendingVerificationKey) {
            this.verifyOTPManager.pendingVerificationKey = pendingVerificationKey;
            this.verifyOTPManager.pendingVerificationPhone = input.mobilePhone;
            this.loginUIManager.pendingSetupCompletion = false;
            this.loginUIManager.pendingVerifyPhone = true;
            await this.verifyOTPManager.sendVerificationCode(true);
        }
        else {
            this.bannerUIManager.displayBanner({
                type: "ERROR",
                text: t("Something went wrong. Please try logging in again."),
                durationInMS: 6000,
            });
            this.socialLoginAuthManager.resetAuth();
            this.loginUIManager.pendingSetupCompletion = false;
        }
    }
}
